import './Projects.css';

const projects = [
  {
    id: 0,
    title: 'DailySync.AI',
    tag: 'AI Platform',
    desc: 'AI-powered platform for remote teams with async updates, automated summaries, and team insights.',
    highlights: [
      'Built AI-powered dashboard with leave, WFH, events & standup logs',
      'Developed note feature with full CRUD & state management',
      'Built clock in/out system with note functionality',
      'Created custom RichTextEditor component',
      'Improved responsive design across mobile & tablets',
      'Integrated backend APIs with loading/error state handling',
    ],
    tech: ['React', 'TypeScript', 'Mantine UI', 'PostgreSQL', 'REST API'],
    color: '#c9f542',
    emoji: '🤖',
    featured: true,
  },
  {
    id: 1,
    title: 'KhelConnect',
    tag: 'Sports Platform',
    desc: 'A structured sports management system for school registration, player profiling, and team management.',
    highlights: [
      'Built reusable form components: multi-file uploaders, custom date-range pickers',
      'Designed school registration & district authority verification workflow',
      'Developed player portfolio system for long-term sports profiling',
      'Created team management across different competition levels',
    ],
    tech: ['React', 'Tailwind CSS', 'TypeScript', 'REST API'],
    color: '#42c9f5',
    emoji: '⚽',
    featured: true,
  },
  {
    id: 2,
    title: 'Online Clothing Store',
    tag: 'E-Commerce',
    desc: 'Full-featured e-commerce platform for high-quality apparel with admin dashboard.',
    highlights: [
      'Built comprehensive dashboard for CRUD on products, categories & brands',
      'Implemented secure user registration/login system',
      'Added product search, category filtering & checkout flow',
    ],
    tech: ['React', 'Chakra UI', 'PostgreSQL', 'REST API'],
    color: '#f542c9',
    emoji: '👗',
    featured: false,
  },
  {
    id: 3,
    title: 'Bakery Website',
    tag: 'Landing Page',
    desc: 'Responsive bakery landing page with clean layout and user-friendly visual hierarchy.',
    highlights: [
      'Built hero banner, about, product showcase & contact sections',
      'Ensured clean layout structure and visual hierarchy',
      'Fully responsive across all device sizes',
    ],
    tech: ['HTML5', 'Tailwind CSS'],
    color: '#f5a742',
    emoji: '🥐',
    featured: false,
  },
];

export default function Projects() {
  return (
    <section className="projects section" id="projects">
      <div className="container">
        <div className="section-label">
          <span className="label-line" />
          <span>Projects</span>
        </div>
        <h2 className="section-title">Things I've built</h2>

        <div className="projects-list">
          {projects.filter(p => p.featured).map((p, i) => (
            <div
              className="project-featured"
              key={p.id}
              style={{ '--proj-color': p.color, animationDelay: `${i * 100}ms` }}
            >
              <div className="proj-left">
                <div className="proj-emoji-wrap">
                  <span className="proj-emoji">{p.emoji}</span>
                </div>
                <div className="proj-tag">{p.tag}</div>
                <h3 className="proj-title">{p.title}</h3>
                <p className="proj-desc">{p.desc}</p>
                <div className="proj-tech">
                  {p.tech.map(t => <span key={t} className="tech-pill">{t}</span>)}
                </div>
              </div>
              <div className="proj-right">
                <div className="proj-highlights-label">Key Contributions</div>
                <ul className="proj-highlights">
                  {p.highlights.map((h, j) => (
                    <li key={j}>
                      <span className="hi-dot" />
                      {h}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="projects-small-grid">
          {projects.filter(p => !p.featured).map((p) => (
            <div
              className="project-small"
              key={p.id}
              style={{ '--proj-color': p.color }}
            >
              <div className="ps-top">
                <span className="proj-emoji sm">{p.emoji}</span>
                <span className="proj-tag">{p.tag}</span>
              </div>
              <h3 className="proj-title sm">{p.title}</h3>
              <p className="proj-desc sm">{p.desc}</p>
              <ul className="proj-highlights sm">
                {p.highlights.map((h, j) => (
                  <li key={j}><span className="hi-dot" />{h}</li>
                ))}
              </ul>
              <div className="proj-tech">
                {p.tech.map(t => <span key={t} className="tech-pill">{t}</span>)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
